export default __webpack_public_path__ + "static/media/kitchen3-afterK-1024w.957ea58d.webp";